// Phase 9 — role hook used by AppShell (to hide the ADMIN group) and by
// the CommandPalette (to filter admin-only pages from the Pages list).
//
// Thin wrapper over the existing AuthContext. We keep the API surface
// deliberately small so callers don't reach into AuthContext for
// role-adjacent behaviour.
import { useAuth } from "@/auth/AuthContext";

export default function useUserRole() {
    const { user, isAdmin, isSuperadmin } = useAuth();
    const role = user?.role || null;
    return {
        role,
        isAdmin: Boolean(isAdmin),
        isSuperadmin: Boolean(isSuperadmin),
        // Convenience alias used by AppShell / CommandPalette when deciding
        // whether to surface the ADMIN nav group.
        canSeeAdmin: Boolean(isAdmin),
    };
}
